import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT_GET_LIST_CLASS,
  ENDPOINT_SAVE_INTERVIEW,
  ENDPOINT_SET_MANAGER_RESPONSABILITY_THE_CLASS,
  ENDPOINT_SET_OWNER_CLASS,
} from './constants';

export function useClassService() {
  const { backendGet, backendPost } = Sebrae.useBackend();

  const getListClass = React.useCallback(
    (data = {}) => backendGet(`${ENDPOINT_GET_LIST_CLASS}`, data),
    [backendGet],
  );

  const listGestorres = React.useCallback(
    (data = {}) => backendGet(`${ENDPOINT_SET_OWNER_CLASS}`, data),
    [backendGet],
  );

  const creteNewInterviewForLandigpage = React.useCallback(
    (interview) => backendPost(`${ENDPOINT_SAVE_INTERVIEW}`, interview),
    [backendPost],
  );

  const setResponsabilityManager = React.useCallback(
    ({ idClassRoom, idMnagerResponsible }) =>
      backendPost(
        `${ENDPOINT_SET_MANAGER_RESPONSABILITY_THE_CLASS}?idClassRoom=${idClassRoom}&idMnagerResponsible=${idMnagerResponsible}`,
      ),
    [backendPost],
  );

  return {
    getListClass,
    creteNewInterviewForLandigpage,
    setResponsabilityManager,
    listGestorres,
  };
}
